import React, { useState } from 'react';
import '../App.css';

function Header() {
  const navItems = [
    { id: 'home', label: '首页', anchor: '#main-visual' },
    { id: 'advantages', label: '方案优势', anchor: '#advantages' },
    { id: 'scenarios', label: '应用场景', anchor: '#scenarios' },
    { id: 'architecture', label: '技术架构', anchor: '#architecture' },
    { id: 'pricing', label: '定价', anchor: '#pricing' },
  ];
  const [open, setOpen] = useState(false);
  return (
    <nav className="header-nav">
      <div className="nav-mobile-bar">
        <span className="nav-logo">千流智能</span>
        <button className="nav-hamburger" onClick={() => setOpen(v => !v)} aria-label="菜单">
          <span className={open ? 'nav-hamburger-icon open' : 'nav-hamburger-icon'}></span>
        </button>
      </div>
      <ul className={open ? 'nav-list nav-list-mobile open' : 'nav-list nav-list-mobile'}>
        {navItems.map(item => (
          <li key={item.id} onClick={() => setOpen(false)}><a href={item.anchor}>{item.label}</a></li>
        ))}
      </ul>
      <ul className="nav-list nav-list-pc">
        {navItems.map(item => (
          <li key={item.id}><a href={item.anchor}>{item.label}</a></li>
        ))}
      </ul>
    </nav>
  );
}
export default Header; 